import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/Home.vue')
    },
    {
        path: '/nav',
        name: 'Nav',
        component: () => import('../views/Nav.vue')
    },
    {
        path: '/chat',
        name: 'Chat',
        component: () => import('../views/Chat.vue')
    },
    {
        path: '/propose',
        name: 'Propose',
        component: () => import('../views/Propose.vue')
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
